import React, { useState, useEffect } from "react";
import { useAuthStore } from "../store/store";
import { useParams } from "react-router-dom";

export default function InvestmentPlanEditor() {
  const { id } = useParams();
  // const [selectedPlan, setSelectedPlan] = useState("gold");
  const { investmentPlanUpdate, getInvestmentPlans } = useAuthStore();
  const [planData, setPlanData] = useState({});

  useEffect(() => {
    const fetchInvestmentPlans = async () => {
      try {
        const response = await getInvestmentPlans(id);
        if (response?.data) {
          // console.log(response.data);
          setPlanData(response.data[0]);
        }
      } catch (error) {
        console.error("Error fetching investment plans:", error);
      }
    };
    fetchInvestmentPlans();
  }, [id]);

  // const handlePlanChange = (e) => {
  //   setSelectedPlan(e.target.value);
  // };

  const handleInputChange = (e) => {
    setPlanData({ ...planData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    try {
      const response = await investmentPlanUpdate({
        ...planData,
        _id: id,
      });
      if (response?.data) {
        alert("Plan updated successfully!");
        // console.log(response.data);
        // setPlanData(response.data);
      }
    } catch (error) {
      console.error("Error  update plans:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all hover:scale-105">
        <div className="p-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-8 text-center">
            Investment Plan Editor
          </h1>
          <div className="mb-8">
            {/* <label className="block text-gray-700 text-sm font-medium mb-2">
              Select Plan
            </label>
            <select
              className="w-full p-3 border border-gray-300 rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              value={selectedPlan}
              onChange={handlePlanChange}
            >
              <option value="gold">Gold Plan</option>
              <option value="silver">Silver Plan</option>
              <option value="starter">Starter Plan</option>
            </select> */}
          </div>
          <div className="space-y-6">
            {[
              { label: "Investment Plan Name", name: "investmentPlanName" },
              { label: "Interest Rate", name: "interestRate" },
              { label: "Investment Limit", name: "investmentLimit" },
              { label: "Returns", name: "returns" },
              { label: "Investment Duration", name: "investmentDuration" },
              { label: "Capital Growth", name: "capitalGrowth" },
              { label: "Risk Level", name: "riskLevel" },
              { label: "Total Return", name: "totalReturn" },
            ].map((field) => (
              <div key={field?.name} className="space-y-2">
                <label className="block text-gray-700 text-sm font-medium">
                  {field?.label}
                </label>
                <input
                  type="text"
                  name={field?.name}
                  value={planData[field?.name] || ""}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                />
              </div>
            ))}
          </div>
          <button
            onClick={handleUpdate}
            className="w-full mt-8 bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 px-6 rounded-lg shadow-lg hover:from-blue-700 hover:to-blue-800 transition-all transform hover:scale-105 active:scale-95"
          >
            Update Plan
          </button>
        </div>
      </div>
    </div>
  );
}
